import { useCallback } from 'react';
import { useMemo } from 'react';
import { useState } from 'react';

export type UseHasChangedSinceSubmissionScalarValue = string | number | null;

export interface UseHasChangedSinceSubmissionParams<
  T extends UseHasChangedSinceSubmissionScalarValue,
> {
  initialValue: T;
  currentValue: T;
}

export interface UseHasChangedSinceSubmissionPayload<
  T extends UseHasChangedSinceSubmissionScalarValue,
> {
  trackSubmission: (newValue: T) => void;
  hasChangedSinceSubmission: boolean;
  lastSubmittedValue: T;
}

export const useHasChangedSinceSubmission = <
  T extends UseHasChangedSinceSubmissionScalarValue,
>({
  initialValue,
  currentValue,
}: UseHasChangedSinceSubmissionParams<T>): UseHasChangedSinceSubmissionPayload<T> => {
  const [lastSubmittedValue, setLastSubmittedValue] = useState<T>(initialValue);

  const trackSubmission = useCallback((newValue: T) => {
    setLastSubmittedValue(newValue);
  }, []);

  const hasChangedSinceSubmission = useMemo(() => {
    return currentValue !== lastSubmittedValue;
  }, [currentValue, lastSubmittedValue]);

  return { hasChangedSinceSubmission, trackSubmission, lastSubmittedValue };
};
